import React from "react";
import "../styles/uniformFeatures.scss";
import { FaCheckCircle, FaShieldAlt, FaTint, FaRegSmile } from "react-icons/fa"; // Koristimo ikone

const featuresData = [
  {
    title: "Visok kvalitet materijala",
    description:
      "Uniforme izrađene od materijala vrhunskog kvaliteta, pružajući dugotrajnost i udobnost tokom nošenja.",
    icon: <FaCheckCircle />
  },
  {
    title: "Otpornost na fleke",
    description:
      "Materijali tretirani za otpornost na fleke, omogućavajući lakše čišćenje i održavanje.",
    icon: <FaTint />
  },
  {
    title: "Bezbednosna zaštita",
    description:
      "Uniforme sa reflektivnim elementima i dodatnom zaštitom za rad u opasnim uslovima.",
    icon: <FaShieldAlt />
  },
  {
    title: "Ergonomski dizajn",
    description:
      "Dizajnirane za maksimalan komfor i fleksibilnost tokom rada, prilagođene potrebama korisnika.",
    icon: <FaRegSmile />
  }
];

const UniformFeatures = () => {
  return (
    <div className="uniform-features-container">
      <h2 className="title">Karakteristike Uniformi</h2>
      <div className="features-grid">
        {featuresData.map((feature, index) =>
          <div key={index} className="feature-card">
            <div className="feature-icon">
              {feature.icon}
            </div>
            <h3>
              {feature.title}
            </h3>
            <p>
              {feature.description}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UniformFeatures;
